<template>

<div class="date" :data-theme="theme" :data-size="size">

	<div class="date-valid" v-if="date">

		<div class="date-year" v-if="yearFirst">{{ date | formatDate('YYYY') }}</div>
		<div class="date-day" v-if="dayFirst">{{ date | formatDate('DD') }}</div>
		<div class="date-month">{{ date | formatDate('MMM') }}</div>
		<div class="date-day" v-if="!dayFirst">{{ date | formatDate('DD') }}</div>
		<div class="date-year" v-if="!yearFirst">{{ date | formatDate('YYYY') }}</div>

	</div>

	<div class="date-invalid" v-if="!date">

		{{ invalid }}

	</div>

</div>

</template>

<script>

export default {

	props: ['date', 'theme', 'size', 'invalid'],

	computed: {

		yearFirst: function() {

			return this.$store.getters['session/config'].other.date === 'YYYY/MM/DD'

		},

		dayFirst: function() {

			return this.$store.getters['session/config'].other.date === 'DD/MM/YYYY'

		}

	}

}

</script>

<style scoped>

.date-valid {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	font-family: 'Roboto Mono', monospace;
	text-transform: uppercase;
	justify-content: space-between;
	width: 41px;
}

.date[data-size="medium"] .date-valid {
	width: 48px;
	display: grid;
	grid-template-columns: 1fr 1fr;
	justify-content: center;
}

.date[data-size="large"] .date-valid {
	width: 70px;
	display: grid;
	grid-template-columns: 1fr 1fr;
	justify-content: center;
}

.date-month {
	font-size: 12px;
	line-height: 12px;
	padding-right: 2px;
	font-weight: 400;
	color: #444;
}

.date-day {
	font-size: 12px;
	line-height: 12px;
	font-weight: 500;
	color: #333;
}

.date-year {
	font-size: 16px;
	line-height: 16px;
	font-weight: 300;
	color: #999;
}

.date-invalid {
	color: #ccc;
    font-weight: 400;
    font-size: 14px
}

.date[data-theme="white"] .date-day,
.date[data-theme="white"] .date-year,
.date[data-theme="white"] .date-month {
	color: #fff!important;
	font-weight: 500;
}

.date[data-size="medium"] .date-day,
.date[data-size="medium"] .date-month {
	font-size: 16px;
	color: #4881bb;
	line-height: 16px;
	padding-right: 0px;
	font-weight: 700;
}

.date[data-size="medium"] .date-year {
	font-size: 20px;
	text-align: center;
	line-height: 20px;
	grid-column: span 2;
	color: #4881bb;
}

.date[data-size="large"] .date-day,
.date[data-size="large"] .date-month {
	font-size: 22px;
	color: #4881bb;
	line-height: 22px;
	padding-right: 0px;
	font-weight: 700;
}

.date[data-size="large"] .date-year {
	font-size: 28px;
	text-align: center;
	line-height: 30px;
	grid-column: span 2;
	color: #4881bb;
}

</style>